import CharacterAvatar from './CharacterAvatar';
import CharacterAvatarPortrait from './CharacterAvatarPortrait';

export default CharacterAvatar;
export { CharacterAvatar, CharacterAvatarPortrait };
